import { cn } from "@/lib/utils";
import { getIn, useFormikContext } from "formik";
import { CheckIcon } from "lucide-react";
import { Fragment } from "react";

const Checkbox = ({ value, onToggle, className = "" }) => {
  return (
    <label
      className={cn(
        "p-0.5 rounded size-5 transition-all cursor-pointer flex items-center justify-center",
        "ring-1 ring-inset",
        value
          ? "bg-blue-500 text-white ring-blue-500"
          : "bg-secondary/50 ring-foreground/20",
        className
      )}
    >
      {value ? <CheckIcon className="size-4" /> : <Fragment />}
      <input
        type="checkbox"
        checked={value}
        className="hidden"
        onChange={() => onToggle(!value)}
      />
    </label>
  );
};

export const CheckboxField = ({ name, className = "" }) => {
  const { values, setFieldValue } = useFormikContext();
  const value = !!getIn(values, name);

  return (
    <Checkbox
      value={value}
      className={className}
      onToggle={(value) => {
        setFieldValue(name, value);
      }}
    />
  );
};
export default Checkbox;
